import React, { useEffect, useState } from "react";
import { NewNavbar, BreadCrumbsNew, NewFooter } from "../../components";
import { useParams, useLocation, Link } from "react-router-dom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import PageLoader from "../../components/loader/PageLoader";
import { BloodTestContactForm } from "../BloodTesting/BloodTestcomponents/BloodTestContactForm";
import { Collapse, Typography } from "antd";
import { SingleViewTabsTravel } from "../../components/SingleViewComponents/SingleViewTabs/SingleViewTabsTravel";
import { get } from "../../services/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, deleteFromCartById } from "../../redux/slices/CartSlice";
import { message } from "antd";
import Seo from "../../components/Seo";
import VaccineManualBooking from "./VaccineManualBooking";
import { buildTravelVaccineSchema } from "../../lib/structuredData";
import {
  buildBreadcrumbListSchema,
  buildSchemaGraph,
  formatPageTitle,
  shopUrl,
  stripHtml,
} from "../../lib/seoUtils";

const { Panel } = Collapse;
const { Text } = Typography;

const TravelClinicDetail = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart?.cartItems) || [];

  const [isLoading, setIsLoading] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [data, setData] = useState(null);
  const [isAddingCart, setIsAddingCart] = useState(false);
  const [isItemInCart, setIsItemInCart] = useState(false);
  const isManualBooking = (item) => item.requiresManualBooking;
  const [isManualVisible, setIsManualVisible] = useState(false);
  const [manaulItem, setManualItem] = useState(null);

  const breadcrumbs = [
    { label: "Home", path: "/" },
    {
      label: "Travel Clinic",
      path: "/travel-clinic",
    },
    {
      label: 'Vaccination By Diseases',
      path: `/travel-clinic/vaccinations-by-diseases`,
    },
    { label: data?.name },
  ];

  useEffect(() => {
    fetchData();
  }, [slug]);
  useEffect(() => {
    console.log("Data State:", data);
  }, [data]);

  const fetchData = async () => {
    setIsLoading(true);
    setIsNotFound(false);

    try {
      const res = await get(`api/travel-clinic/search-by/${slug}`);
      console.log(res);
      if (res.success) {
        setData(res.data);
        setIsItemInCart(
          cartItems.some((item) => item._id === res.data._id)
        );
        setIsLoading(false);
        setIsNotFound(false);

      } else {
        setData(null);
        setIsLoading(false);
        setIsNotFound(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
      setData(null);
      setIsNotFound(true);
    }
  };

  const AddingToCart = (item) => {
    try {
      setIsAddingCart(true);
      const product = {
        _id: item._id,
        name: item.name,
        unique_code: "",
        price: item.price,
        type: "",
        section: "travel-clinic",
        serviceId: item?.serviceId,
        serviceAdonsId: item?.serviceAdonsId,
      };
      dispatch(addToCart(product));
      setIsItemInCart(true);
      message.success("Added to cart");
    } catch (error) {
      console.error(error);
      message.error("Failed to add to cart");
    } finally {
      setIsAddingCart(false);
    }
  };

  const removeFromCart = (cartItemId) => {
    dispatch(deleteFromCartById(cartItemId));
    setIsItemInCart(false);
  };
  const handleManualClick = async (item) => {
    setManualItem(item);
    setIsManualVisible(true);
  };

  const handleManualClose = async () => {
    setManualItem(null);
    setIsManualVisible(false);
  };

  const baseUrl = shopUrl();
  const pageUrl = shopUrl(`/travel-clinic/vaccinations-by-diseases/${slug}`);
  const pageImage = shopUrl("/assets/icons/travel-single.png");
  const structuredData =
    !isLoading && data
      ? buildSchemaGraph([
          buildTravelVaccineSchema(data, slug, baseUrl),
          buildBreadcrumbListSchema([
            { name: "Home", url: shopUrl("/") },
            {
              name: "Travel Clinic",
              url: shopUrl("/travel-clinic"),
            },
            {
              name: "Vaccinations by Diseases",
              url: shopUrl("/travel-clinic/vaccinations-by-diseases"),
            },
            { name: data.name, url: pageUrl },
          ]),
        ])
      : null;

  return (
    <>
      <Seo
        title={
          data?.name
            ? formatPageTitle(`${data.name} — Travel Vaccinations`)
            : formatPageTitle("Travel Vaccinations")
        }
        description={
          data ? stripHtml(data.shortDescription || "") : undefined
        }
        canonical={pageUrl}
        url={pageUrl}
        image={pageImage}
        structuredData={structuredData}
      />

      <div className="">
        {isLoading && <PageLoader />}
        <div className="breadcrumnb-img-bg breadcrumnb-img-bg-travel-detail">
          <div className="container">
            <NewNavbar />
            <BreadCrumbsNew breadcrumbs={breadcrumbs} title={data?.name} />
          </div>
        </div>
        {!isLoading && data && (
          <div className="container travel-detail-container detailed-page-cont-inner my-lg-20 my-10">
            <div className="row">
              <div className="col-lg-5">
                <div className="h-575 blood-desktop-img">
                  <img
                    src="/assets/icons/travel-single.png"
                    className="img-fluid h-100 w-100"
                    alt={data?.name ? `${data.name} travel vaccination` : "Travel vaccination"}
                  />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="Card border-0 bg-transparent h-100">
                  <div className="card-body">
                    <p className="main-text fs-45 m-lg-0 mt-8 text-center text-lg-start">
                      £ {data?.price}
                    </p>
                    <p className="metropill fs-6 my-10 my-md-13">{data?.shortDescription}</p>
                  </div>
                  <div className="card-add-wrap-travel">
                    {/* <label htmlFor="">Dose:</label> */}
                    <div className="card-footer justify-content-center justify-content-lg-start d-flex">
                      {isManualBooking(data) ? (
                        <button
                          type="button"
                          className="btncust btn-pad w-auto metropill m-0"
                          onClick={() => handleManualClick(data)}

                        >
                          ADD TO BASKET
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btncust btn-pad w-auto metropill m-0"
                          disabled={isAddingCart}
                          onClick={() =>
                            isItemInCart
                              ? removeFromCart(data?._id)
                              : AddingToCart(data)
                          }
                        >
                          {isAddingCart
                            ? "PLEASE WAIT..."
                            : isItemInCart
                              ? "REMOVE FROM BASKET"
                              : "ADD TO BASKET"
                          }
                        </button>
                      )}


                    </div>
                  </div>
                  <div className="mt-md-15 mt-10">
                    <ul className="navbar-nav flex-column gap-2 align-items-md-start list-detail-page">
                      <li>
                        <div className="d-flex gap-2 align-items-center">
                          <img
                            src="/assets/icons/plus-thin-p.png"
                            width={10}
                            alt="point"
                          />
                          <span className="fs-16 metropill-thin">
                            {data.points.point1}
                          </span>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex gap-2 align-items-center">
                          <img
                            src="/assets/icons/plus-thin-p.png"
                            width={10}
                            alt="point"
                          />
                          <span className="fs-16 metropill-thin">
                            {data.points.point2}
                          </span>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex gap-2 align-items-center">
                          <img
                            src="/assets/icons/plus-thin-p.png"
                            width={10}
                            alt="point"
                          />
                          <span className="fs-16 metropill-thin">
                            {data.points.point3}
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="tabs-travel-detail tabs-single col-lg-12">
                <SingleViewTabsTravel data={data} />
              </div>
            </div>
          </div>
        )}
        <div className="form-detail-page">
          <BloodTestContactForm />
        </div>

        <NewFooter />
        <VaccineManualBooking
          isVisible={isManualVisible}
          onClose={handleManualClose}
          item={manaulItem}
        />
      </div>
    </>
  );
};

export { TravelClinicDetail };
